// @flow

const CCActionTypes = {
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  CLEAR_NOTIFICATIONS: 'CLEAR_NOTIFICATIONS',
  DELETE_NOTIFICATION: 'DELETE_NOTIFICATION',
  SET_JOINING_STATUS: 'SET_JOINING_STATUS',
  SET_MODE: 'SET_MODE',
  SET_SHOW_BUBBLE_ABOVE_CC_MODE: 'SET_SHOW_BUBBLE_ABOVE_CC_MODE',
};

export default CCActionTypes;
